import { createApp } from "vue";
import Joins from "./Joins.vue";

const app = createApp({
  components: {
    "joins-component": Joins,

  },
}).mount("#container-joins");
